class Overlay {
  constructor(zIndex = 40) {
    this.classes = {
      active: 'overlay--active',
    };

    this.element = document.createElement('div');
    this.element.classList.add('overlay');
    this.element.style.zIndex = zIndex;

    document.body.appendChild(this.element);

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  toggle() {
    if (this.element.classList.contains(this.classes.active)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.element.classList.add(this.classes.active);
  }

  hide() {
    this.element.classList.remove(this.classes.active);
  }
}

export default Overlay;
